import { render, staticRenderFns } from "./calculate.vue?vue&type=template&id=3c68e68d&scoped=true"
import script from "./calculate.vue?vue&type=script&lang=js"
export * from "./calculate.vue?vue&type=script&lang=js"
import style0 from "./calculate.vue?vue&type=style&index=0&id=3c68e68d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c68e68d",
  null
  
)

export default component.exports